import { ImagePlus } from "lucide-react";

export const ImageSlot = ({ src, alt, label, className = "", testId }) => {
  if (src) {
    return (
      <div className={`overflow-hidden bg-[#EFE9E0] ${className}`} data-testid={testId}>
        <img
          src={src}
          alt={alt || ""}
          loading="lazy"
          className="w-full h-full object-cover transition-transform duration-[1600ms] ease-out hover:scale-[1.03]"
        />
      </div>
    );
  }
  return (
    <div
      data-testid={testId ? `${testId}-placeholder` : undefined}
      className={`relative flex flex-col items-center justify-center text-center bg-[#EFE9E0] border border-dashed border-[#B89A5E]/50 ${className}`}
    >
      <ImagePlus size={22} strokeWidth={1.2} className="text-[#B89A5E]" />
      <div className="mt-3 text-[10px] uppercase tracking-[0.28em] text-[#2A1F27]/60 px-4">
        Image placeholder
      </div>
      {label && (
        <div className="mt-1 font-display italic text-base text-[#2A1F27]/70 px-6">{label}</div>
      )}
      <div className="mt-2 text-[10px] text-[#2A1F27]/40 px-6">Upload your own photo in Admin → Bridal</div>
    </div>
  );
};
